import {useSyncExternalStore} from 'react';
import {checkIfAbilityResultHeldForUnit, subscribeToAbilityResultHolds} from './abilityResultHolds';

/**
 * Придержан ли итог способности этого отряда: сердце соблазна или бомба еще
 * летят (см. abilityResultHolds). Пока придержан, футер не открывает формулу
 * броска — иначе он выдал бы исход раньше, чем его покажет поле
 *
 * @param {string} [unitId]
 * @returns {boolean}
 */
export const useIsAbilityResultHeld = (unitId) => useSyncExternalStore(
  subscribeToAbilityResultHolds,
  () => checkIfAbilityResultHeldForUnit(unitId)
);
